module.exports = __webpack_public_path__ + "img/20190819160258567.09a64baf.png";